export function timestamp(from: number | null | undefined): string | null {
	if (from === null || from === undefined) {
		return null;
	}

	return new Date(from).toISOString();
}
